import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";

import "@/rubik.css";              // self-hosted Rubik @font-face (заголовки лендинга)
import "@/montserrat.css";         // self-hosted Montserrat (подзаголовки/текст лендинга)
import "@/index.css";
import "@/lib/i18n";
import "@/stores/theme";          // applies persisted theme on load
import App from "@/App";
import { ensureDevSession } from "@/lib/devAuth";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 },
  },
});

// Fire-and-forget dev auth bootstrap. The backend's /api/dev/bootstrap-session
// (APP_ENV=local only) mints a real Supabase-shape JWT for the seeded admin,
// so /api/me, /api/chats, etc. all authenticate. Replace this with the real
// /login flow when it ships.
void ensureDevSession();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
